import * as bootstrap from "bootstrap";
import Rails from "@rails/ujs";

import "./views_shared/intercom";
import "./views_shared/one_signal";
import "./qahoy"; // Initialize ahoy tracking

window.bootstrap = bootstrap;

// Guard against double initialization (e.g., when multiple bundles load views_shared)
if (!window.railsUjsStarted) {
  Rails.start();
  window.railsUjsStarted = true;
}
